import "./Loader.css";

const Loader = () => {
  return (
    <div>
      <div className="loader" id="spinner">
        <img src="/scope/logo.png" className="central-icon" alt="loader" />
      </div>
    </div>
  );
};

export default Loader;
